import React, { useState } from 'react';
import Fedapay from './Providers/Fedapay';
import PayTech from './Providers/PayTech';
import Stripe from './Providers/Stripe/Stripe';
import AZPAY from './Providers/AZPAY';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Create = ({item, options,onSuccess}) => {
    const [showStripe, setShowStripe] = useState(false);
    const [showAZPAY, setShowAZPAY] = useState(false);
    const { t, i18n } = useTranslation();

    const location = useLocation();
    

    
    
    let navigate = useNavigate();
    if(!item)
        item = {
            'id': 2,
            'name': 'Bag',
            'price': 12000,
        }
    if(!options)
        options = {
            id_currency: 3,
            success_url: window.location.origin + '/success',
            cancel_url: window.location.href,
            customer: {
                id: 106,
                first_name: 'Jean',
                last_name: 'DUPONT',
                email: 'jeandupont@gmail.com',
                phone: '64000001',
                code_country: 'BJ'
            },
            seller_number: 1
        }
    return (
        showStripe
        ? <Stripe item={item} options={options}  onSuccess={onSuccess} />
        : <div className="border rounded-lg w-11/12 lg:w-1/2 mx-auto bg-gradient-to-b from-white to-gray-50 shadow-xl mt-6 overflow-hidden">
            {
              showAZPAY
              ? <AZPAY item={item} options={options} onSuccess={onSuccess} />
              : <>
                  <div className="bg-gray-800 text-white py-3 px-4">
                    <h1 className="text-xl text-center font-bold">{location.pathname !== '/Dashboard/Credit_AZ/Recharger' ? 'Choisir un mode de paiement' : 'Choisir un mode de recharge'} </h1>
                  </div>
                  <div className="p-6">
                    {
                      options.customer.code_country === 'CI' || options.customer.code_country === 'SN'
                      ? <PayTech item={item} options={options} onSuccess={onSuccess} />
                      : <Fedapay item={item} options={options} onSuccess={onSuccess} />
                    }
                    <div className="mt-6 space-y-4">
                      <button 
                        onClick={() => setShowStripe(true)}
                        className="text-white bg-amber-600 hover:bg-amber-700 px-4 py-3 rounded-lg text-center w-[300px] mx-auto block font-medium transition-colors duration-200 shadow-md hover:shadow-lg flex items-center justify-center"
                      >
                        <span className="mr-2">💳</span> {t("Carte Bancaire")}
                      </button>
                    {
                      location.pathname !== '/Dashboard/Credit_AZ/Recharger' && (
                        <button 
                          onClick={() => setShowAZPAY(true)}
                          className="text-white bg-[#233D4D] hover:bg-[#326b8f] px-4 py-3 rounded-lg text-center w-[300px] mx-auto block font-medium transition-colors duration-200 shadow-md hover:shadow-lg flex items-center justify-center"
                        >
                          <span className="mr-2">🔄</span> {t("AZ PAY")}
                        </button>
                      )
                    } 
                    </div>
                  </div>
                </>
            }
          </div>
                    
    );
};



export default Create;